export function width(domElement) {	
    var rects = domElement.getClientRects();
    return rects[0].width;
};

export function height(domElement) {
	var rects = domElement.getClientRects();
    return rects[0].height;
};


// WEBPACK FOOTER //
// ./app/utils/dimensions.js